import { INJECT_FRAGMENT_CONTEXT } from "../helpers/symbols.js";
import { getRuntimeOptionValue } from "../helpers/runtimeHelpers/index.js";
import { computed, inject } from "#imports";
import { globalOptionsDefaults } from "#blokkli-build/default-global-options";
export function defineBlokkliFragment(config) {
  const ctx = inject(
    INJECT_FRAGMENT_CONTEXT,
    null
  );
  const optionKeys = [
    ...Object.keys(config.options || {}),
    ...config.globalOptions || []
  ];
  const options = computed(() => {
    const result = optionKeys.reduce((acc, key) => {
      acc[key] = ctx.options.value[key];
      return acc;
    }, {});
    optionKeys.forEach((key) => {
      const definition = config.options?.[key] || globalOptionsDefaults[key];
      if (!definition) {
        return;
      }
      const value = result[key] === void 0 || result[key] === null ? definition.default : result[key];
      result[key] = getRuntimeOptionValue(definition, value);
    });
    return result;
  });
  return { ...ctx, options };
}
